import { EducationalInfoBaseType } from '@Services/educationalInfo/educationalInfo.types';

export type EducationEntity = 'type' | 'language' | 'year' | 'section';

export type EducationTypeRow = EducationalInfoBaseType & {
	educationLanguages: EducationalInfoBaseType[];
	educationYears: EducationalInfoBaseType[];
};

export type EducationYearRow = EducationalInfoBaseType & {
	educationSections: EducationalInfoBaseType[];
};

export type EducationAllData = {
	types: EducationTypeRow[];
	languages: EducationalInfoBaseType[];
	years: EducationYearRow[];
	sections: EducationalInfoBaseType[];
};

export type EducationSavePayload = {
	id?: number;
	name: string;
	language_ids?: number[];
	year_ids?: number[];
	section_ids?: number[];
};

export const EDUCATION_ENTITY_LABELS: Record<EducationEntity, string> = {
	type: 'Type',
	language: 'Language',
	year: 'Year',
	section: 'Section',
};
